import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCatalogReviewsResponse, transformCatalogRatingResponse, transformPostCatalogReviewsResponse } from './transformers.js';
import defaultClient from 'axios';

const getCatalogReviews = async ({ client , controller , fields ={} , where ={} , order =[] , limit =1000000 , offset =0 , skip =0  } = {})=>await client.get(`/V1/catalog/reviews`, {
        signal: controller?.signal,
        params: {
            filter: {
                fields,
                where,
                order,
                limit,
                offset,
                skip
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogReviewsResponse)
        ]
    });
getCatalogReviews.key = 'getCatalogReviews';
const getCatalogRating = async ({ client , controller , id  } = {})=>await client.get(`/V1/catalog/rating/${id}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogRatingResponse)
        ]
    });
getCatalogRating.key = 'getCatalogRating';
const postCatalogReviews = async ({ client , controller , title , description , user , value , productId  } = {})=>await client.post(`/V1/catalog/reviews/`, {
        title,
        detail: description,
        nickname: user,
        ratings: [
            {
                rating_name: 'General',
                percent: value * 100 / 5,
                value
            }
        ],
        entity_pk_value: productId
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPostCatalogReviewsResponse)
        ]
    });
postCatalogReviews.key = 'postCatalogReviews';

export { getCatalogRating, getCatalogReviews, postCatalogReviews };
